<template>
  <div 
    class="html-editor"  
    :class="{
      'is-invalid': showError
    }"
  >
    <vue-editor
      ref="editor"
      class="has-background-white"
      id="editor"
      :editorToolbar="customToolbar"
      :editorOptions="editorOptions"
      v-model="text"
    >
    </vue-editor>
    <div class="status-bar has-background-white has-text-right is-size-7">
      <span :class="[textLength <= maxLength ? 'has-text-gray' : 'has-text-carnelian']">
        {{ textLength }}
      </span> / {{ maxLength }}
    </div>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'

export default {
  name: 'fob-html-editor',
  data () {
    return {
      customToolbar: [
        ['bold', 'italic'],
        [{ list: 'ordered' }, { list: 'bullet' }]
      ],
      editorOptions: {
        formats: [
          'bold',
          'italic',
          'list'
        ]
      },
      isMounted: false,
      componentValid: true
    }
  },
  components: {
    'vue-editor': VueEditor
  },
  computed: {
    textLength () {
      if (this.isMounted) {
        if (this.$refs['editor'] != null) {
          return this.$refs['editor'].quill.getLength() - 1
        }
      }
      return 0
    },
    text: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input',
          v
        )
      }
    },
    isValid () {
      return this.textLength <= this.maxLength
    },
    showError () {
      return this.type === 'is-danger'
    }
  },
  props: {
    maxLength: {
      type: Number,
      default: 1000
    },
    value: {
      type: String
    },
    type: {
      type: String
    }
  },
  mounted () {
    this.isMounted = true
  },
  watch: {
    isValid (value) {
      this.componentValid = value
    }
  }
}

</script>

<style scoped lang="scss">

.status-bar {
  border-top: 1px solid #dbdbdb;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}
/deep/ .html-editor {
  &:hover {
    border-color: #c0c0c0;
  }
  &:focus-within {
    // border-color: #8AC2D1;
    border-color: #507d8e;
    -webkit-box-shadow: 0 0 0 0.125em rgba(138, 194, 209, 0.25);
    box-shadow: 0 0 0 0.125em rgba(138, 194, 209, 0.25);
  }
  &.is-invalid {
    border-color: #D8413E !important;
    &:focus-within {
      -webkit-box-shadow: 0 0 0 0.125em rgba(216, 65, 62, 0.25);
      box-shadow: 0 0 0 0.125em rgba(216, 65, 62, 0.25);
    }
  }
  border: 1px solid #dbdbdb;
  border-radius: 3px;

  .quillWrapper {
    border-radius: 3px;
  }
  .ql-editor {
    min-height: 120px;
  }
  .ql-container {
    border: none !important;
    -webkit-box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
    box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  }
  .ql-toolbar {
    border: none !important;
    border-bottom: 1px solid #dedede !important;
  }
}
.ql-container {
  font-family: inherit !important;
  /* border: none !important; */
}

.tab-content {
  padding: 0 !important;
}



</style>


// WEBPACK FOOTER //
// src/components/form/HTMLEditor.vue